<template>
	<q-list class="q-mb-md">
		<q-collapsible icon="fas fa-filter" v-model="open" @click="toggle" :label="getNameFilter">
			<div class="row gutter-sm" v-if="options">
				<div class="col-xs-12 col-sm-12">
					<q-chips-input
						v-model="filters.requester_names"
						:float-label="$t('requester')"
						@remove="removeRequester"
					>
						<q-autocomplete
							@search="searchRequester"
							@selected="selectRequester"
							:debounce="500"
							:min-characters="3"
							:max-results="30"
							:value-field="(v) => `${v.full_name} - ${v.email}`"
						/>
					</q-chips-input>
				</div>

				<div class="col-xs-12 col-sm-12">
					<q-chips-input
						v-model="filters.instructor_names"
						:float-label="$t('instructors')"
						@remove="removeInstructor"
					>
						<q-autocomplete
							@search="searchInstructor"
							@selected="selectInstructor"
							:debounce="500"
							:min-characters="3"
							:max-results="30"
							:value-field="(v) => `${v.full_name} - ${v.email}`"
						/>
					</q-chips-input>
				</div>

				<div class="col-xs-12 col-sm-12">
					<q-input
						v-model="filters.company_branch_name"
						:float-label="$t('location_name')"
						autocomplete="new-password"
						@clear="removeBranch"
						clearable
					>
						<q-autocomplete
							@search="searchBranch"
							@selected="selectBranch"
							:debounce="500"
							:min-characters="3"
							:max-results="30"
							:value-field="
								(e) =>
									`${e.document} ${e.fantasy} - ${e.address.address}${
										e.address.number ? ', ' + e.address.number : ''
									} - ${e.address.city}/${e.address.state}`
							"
							separator
						/>
					</q-input>
				</div>

				<div class="col-xs-12 col-sm-12" v-if="options.appointment_types">
					<q-select
						chips
						multiple
						v-model="filters.appointment_type"
						:options="options.appointment_types"
						:float-label="$t('appointment_type')"
						clearable
					/>
				</div>

				<div class="col-xs-12 col-sm-12" v-if="options.statuses">
					<q-select
						chips
						multiple
						v-model="filters.status"
						:options="options.statuses"
						:float-label="$t('status')"
						clearable
					/>
				</div>

				<div class="col-xs-12 col-sm-6 gutter">
					<q-datetime
						v-model="filters.start_date_display"
						:float-label="$t('creation_date_from')"
						type="datetime"
						format="DD/MM/YYYY HH:mm"
						clearable
					/>
				</div>

				<div class="col-xs-12 col-sm-6 gutter">
					<q-datetime
						v-model="filters.end_date_display"
						:float-label="$t('creation_date_to')"
						type="datetime"
						format="DD/MM/YYYY HH:mm"
						clearable
					/>
				</div>

				<div class="col-xs-12 col-sm-6 gutter">
					<q-datetime
						v-model="filters.event_start_date_display"
						:float-label="$t('event_date_from')"
						type="datetime"
						format="DD/MM/YYYY HH:mm"
						clearable
					/>
				</div>

				<div class="col-xs-12 col-sm-6 gutter">
					<q-datetime
						v-model="filters.event_end_date_display"
						:float-label="$t('event_date_to')"
						type="datetime"
						format="DD/MM/YYYY HH:mm"
						clearable
					/>
				</div>
			</div>
			<div class="row gutter-sm justify-end q-mt-sm">
				<div class="col-xs-12 col-sm-3">
					<q-btn
						color="negative"
						class="full-width"
						:label="$t('clear_filters')"
						icon="fas fa-eraser"
						@click="clearFilter()"
					/>
				</div>
				<div class="col-xs-12 col-sm-3">
					<q-btn
						color="secondary"
						class="full-width"
						:label="$t('apply_filter_plural')"
						icon="fas fa-filter"
						@click="requestFiltered()"
					/>
				</div>
			</div>
		</q-collapsible>
	</q-list>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date
export default {
	name: 'AdminPresentialFilters',

	props: ['options'],

	data() {
		return {
			open: false,
			filters: {
				user_requester: [],
				requester_names: [],
				user_instructor: [],
				instructor_names: [],
				company_branch: [],
				company_branch_name: '',
				company_branch_address: '',
				appointment_type: [],
				status: [],
				start_date: [],
				start_date_display: '',
				end_date: [],
				end_date_display: '',
				event_start_date: [],
				event_start_date_display: '',
				event_end_date: [],
				event_end_date_display: '',
			},
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			presential_filters: 'admin_filters/presential_filters',
		}),

		getHeader() {
			return {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			}
		},

		getNameFilter() {
			if (Object.entries(this.filters).find((a) => a[1] && a[1].length > 0)) {
				return `${this.$t('filter')} <i class="fas fa-exclamation-circle"></i>`
			} else return this.$t('filter')
		},
	},

	methods: {
		requestFiltered() {
			let obj = {
				user_requester: [this.filters.user_requester],
				user_instructor: [this.filters.user_instructor],
				company_branch: [this.filters.company_branch],
				appointment_type: this.filters.appointment_type,
				status: this.filters.status,
				start_date: [this.filters.start_date_display],
				end_date: [this.filters.end_date_display],
				event_start_date: [this.filters.event_start_date_display],
				event_end_date: [this.filters.event_end_date_display],
			}

			this.$emit('requestFiltered', obj)
			this.savePresentialFilters()
			setTimeout(() => {
				this.toggle()
			}, 500)
		},

		clearFilter() {
			this.filters.user_requester = []
			this.filters.requester_names = []
			this.filters.user_instructor = []
			this.filters.instructor_names = []
			this.filters.company_branch = []
			this.filters.company_branch_name = ''
			this.filters.company_branch_address = ''
			this.filters.appointment_type = []
			this.filters.status = []
			;(this.filters.start_date = []), (this.filters.start_date_display = '')
			this.filters.end_date = []
			this.filters.end_date_display = ''
			this.filters.event_start_date = []
			this.filters.event_start_date_display = ''
			this.filters.event_end_date = []
			this.filters.event_end_date_display = ''
			this.$emit('clearAndRequest')
			this.clearStoredFilters()
			setTimeout(() => {
				this.toggle()
			}, 500)
		},

		toggle() {
			this.open = !this.open
		},

		savePresentialFilters() {
			this.$store.dispatch('admin_filters/SET_PRESENTIAL_FILTERS', {
				presential_filters: this.filters,
			})
		},

		loadPresentialFilters() {
			this.filters = this.presential_filters
			setTimeout(() => {
				this.requestFiltered()
			}, 1000)
		},

		clearStoredFilters() {
			this.$store.dispatch('admin_filters/SET_PRESENTIAL_FILTERS', { presential_filters: {} })
		},

		searchInstructor(terms, done) {
			this.$axios
				.get(`/accounts/get_instructors/?search=${terms}`, this.getHeader)
				.then((response) => {
					let users = response.data.map((e) => {
						return { ...e, value: e.id, label: `${e.full_name} - ${e.email}` }
					})

					done(users)
				})
				.catch((e) => {
					done([])
					console.log(e)
				})
		},

		searchRequester(terms, done) {
			this.$axios
				.get(`/accounts/get_users/?search=${terms}`, this.getHeader)
				.then((response) => {
					let users = response.data.map((e) => {
						return { ...e, value: e.id, label: `${e.full_name} - ${e.email}` }
					})

					done(users)
				})
				.catch((e) => {
					done([])
					console.log(e)
				})
		},

		selectInstructor(item, keyboard) {
			if (!keyboard) {
				this.filters.user_instructor.push(item.id)
			}
		},

		selectRequester(item, keyboard) {
			if (!keyboard) {
				this.filters.user_requester.push(item.id)
			}
		},

		removeInstructor({ index, value }) {
			this.filters.user_instructor.splice(index, 1)
			this.filters.instructor_names.splice(index, 1)
		},

		removeRequester({ index, value }) {
			this.filters.user_requester.splice(index, 1)
			this.filters.requester_names.splice(index, 1)
		},

		searchBranch(terms, done) {
			this.$axios
				.get(`/admin_companies/branches/get_branches/?search=${terms}`, this.getHeader)
				.then((response) => {
					let branches = response.data.map((e) => {
						return {
							...e,
							value: e.id,
							label: `${e.document} ${e.fantasy} - ${e.address.address}${
								e.address.number ? ', ' + e.address.number : ''
							} - ${e.address.city}/${e.address.state}`,
						}
					})

					done(branches)
				})
				.catch((e) => {
					done([])
					console.log(e)
				})
		},

		selectBranch(item, keyboard) {
			if (!keyboard) {
				this.filters.company_branch_name = `${item.document} ${item.fantasy} - ${
					item.address.address
				}${item.address.number ? ', ' + item.address.number : ''} - ${item.address.city}/${
					item.address.state
				}`
				this.filters.company_branch_address = `${item.address.address}${
					item.address.number ? ', ' + item.address.number : ''
				} - ${item.address.city}/${item.address.state}`
				this.filters.company_branch = item.id
			}
		},

		removeBranch() {
			this.filters.company_branch_name = ''
			this.filters.company_branch_address = ''
			this.filters.company_branch = []
			this.clearStoredFilters()
		},
	},

	mounted() {
		if (this.presential_filters && this.presential_filters.status) {
			this.loadPresentialFilters()
		}
	},
}
</script>

<style></style>
